
import { defineComponent, ref, watch, PropType } from 'vue'
export default defineComponent({
  name: 'OperatorDialog',
  props: {
    visible: Boolean,
    isEdit: Boolean,
    formData: {
      type: Object as PropType<any>,
      default: () => ({})
    },
    deptTree: {
      type: Array as PropType<any[]>,
      default: () => []
    }
  },
  emits: ['update:visible', 'submit', 'cancel'],
  setup(props, { emit }) {
    const dialogVisible = ref(props.visible)
    const formRef = ref()
    const form = ref<any>({ ...props.formData })
    watch(() => props.visible, val => (dialogVisible.value = val))
    watch(() => props.formData, val => (form.value = { ...val }))
    const rules = {
      parentId: [{ required: true, message: '请选择上级部门', trigger: 'change' }],
      deptName: [{ required: true, message: '请输入运营商名称', trigger: 'blur' }],
      leader: [{ required: true, message: '请输入负责人', trigger: 'blur' }],
      phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
      email: [{ required: true, message: '请输入邮箱', trigger: 'blur' }],
      locationProvince: [{ required: true, message: '请输入省份', trigger: 'blur' }],
      locationCity: [{ required: true, message: '请输入城市', trigger: 'blur' }],
      locationCounty: [{ required: true, message: '请输入县/区', trigger: 'blur' }],
      locationFullName: [{ required: true, message: '请输入所在地', trigger: 'blur' }]
    }
    const handleCancel = () => {
      emit('update:visible', false)
      emit('cancel')
    }
    const handleConfirm = () => {
      formRef.value.validate((valid: boolean) => {
        if (valid) {
          emit('submit', { ...form.value })
          emit('update:visible', false)
        }
      })
    }
    return {
      dialogVisible,
      form,
      formRef,
      rules,
      handleCancel,
      handleConfirm
    }
  }
})
